export default "__VITE_ASSET__GDMyH7LE__"